/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../models/Node';
import { ValidationProblem } from '../models/ValidationProblem';

/**
 * Interface which defines a way to extend the basic document validation rules with additional rules.
 * Validation problems can be custom, or adapted from other validation libraries such as <a href="https://stoplight.io/open-source/spectral/"></a>
 * @class
 */
export interface IDocumentValidatorExtension {
    /**
     * This method should implement the validation of the document and return a list of validation problems.
     * @param {Node} document The document which will be validated.
     * @return {Promise} The list of validation problems
     */
    validateDocument(document : Node) : Promise<Array<ValidationProblem>>;
}


